import React from 'react';
import { connect } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';
import { ErrorBoundary } from 'wsm-error-boundary';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';
import { waitForInvData } from 'wsm-srp-utilities';
import Skeleton from 'wsm-skeleton';
import PropTypes from 'prop-types';
import Form from '../components/Form';

class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		if (isBrowser) {
			waitForInvData(this);
		}
	}

	render() {
		const isMobile = this.props.deviceType === 'MOBILE';

		if (!isBrowser || !window?.DDC?.InvData) {
			return (
				<Skeleton
					skeletonClasses="form-control border-0"
					height={isMobile ? '' : '61px'}
				/>
			);
		}

		return (
			<ErrorBoundary
				errorHandler={(error, errorInfo) => {
					setNewRelicCustomAttribute(
						'SRP ERROR',
						`ws-inv-text-search error boundary.\n${error}`
					);
					const newError = new Error(
						`ws-inv-text-search error boundary.\n${error}`
					);
					newError.originalError = error;
					newError.originalStackTrace = errorInfo.componentStack;
					logger.error(`${newError}\n${newError.originalStackTrace}`);
				}}
			>
				<Form />
			</ErrorBoundary>
		);
	}
}

const mapStateToProps = (_state) => ({
	deviceType: _state.requestData?.deviceType
});

const mapDispatchToProps = (_dispatch) => ({});

WidgetContainer.propTypes = {
	deviceType: PropTypes.string
};

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
